import { Box, Flex, PrimaryButton, Stack } from "flicket-ui";
import { ReactNode } from "react";
import { ExpressCheckoutModal } from "~features/express-checkout";
import { ExpressCheckoutSection } from "./ExpressCheckoutSection";

interface FooterActionBarProps {
  priceInfo: ReactNode;
  buttonText: string;
  onAction: () => void;
  isLoading: boolean;
  isDisabled: boolean;
}

export const FooterActionBar = ({
  priceInfo,
  buttonText,
  onAction,
  isLoading,
  isDisabled,
}: FooterActionBarProps) => {
  return (
    <Stack
      width="100%"
      alignItems="center"
      justifyContent="space-between"
      gap={"1/2"}
    >
      <Box>{priceInfo}</Box>

      <PrimaryButton
        minW={{ sm: 330 }}
        width={{ _: "50%", sm: "auto" }}
        onClick={() => void onAction()}
        isLoading={isLoading}
        disabled={isDisabled}
      >
        {buttonText}
      </PrimaryButton>
      <ExpressCheckoutSection />
      {/* <ExpressCheckoutModal /> */}
    </Stack>
  );
};
